import styled from 'styled-components';

const whiteWithOpacity = (theme) => `${theme.colors.primary.white}E6`;

const ToastWrapper = styled.div`

--toastify-icon-color-error: ${(p) => whiteWithOpacity(p.theme)} !important;
--toastify-icon-color-success: ${(p) => whiteWithOpacity(p.theme)} !important;
--toastify-text-color-light: ${(p) => whiteWithOpacity(p.theme)} !important;
--toastify-z-index: ${(p) => p.theme.zIndex.notifyManager} !important;

.Toastify__toast--error {
  background: ${(p) => p.theme.colors.status.cherryRed};
  top: 50px;
  opacity: 0.9;
  left: -20px;
  min-width: 100vw;
}

.Toastify__toast--success {
  background: ${(p) => p.theme.colors.status.successGreen};
  top: 50px;
  left: -20px;
  min-width: 100vw;
}

.Toastify__toast--warning {
  background: ${(p) => p.theme.colors.status.warningOrange};
  top: 50px;
  left: -20px;
  min-width: 100vw;
}

.Toastify__close-button {
  margin-top: 10px;
  margin-right: 20px;
}

.Toastify__close-button > svg {
  fill: white;
}

.JNM-Toast {
  position: absolute !important;
  top: -12px !important;
  left: -16px !important;
}

@media only screen and (max-width: 480px){
  .JNM-Toast {
    top: 0 !important;
    left: 0 !important;
  }
}
`;

export default ToastWrapper;
